import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface Props {
  message?: string
  onBack?: () => void
  onRetry?: () => void
}

export function ErrorState({ message = 'Something went wrong.', onBack, onRetry }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <AlertTriangle className="h-7 w-7" aria-hidden="true" />
      </div>
      <div>
        <p className="text-lg font-semibold text-foreground">Unable to load</p>
        <p className="mt-1 text-sm text-muted-foreground">{message}</p>
      </div>
      <div className="flex gap-3">
        {onRetry && <Button onClick={onRetry}>Try again</Button>}
        {onBack && (
          <Button variant="outline" onClick={onBack}>
            Go back
          </Button>
        )}
      </div>
    </div>
  )
}
